import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { guardRoute } from "@/lib/permissions";
import { useCan } from "@/lib/rbac";
import { PageHeader } from "@/components/app-shell";

export const Route = createFileRoute("/admin")({
  beforeLoad: ({ location }) => {
    guardRoute(location.pathname);
  },
  head: () => ({ meta: [{ title: "Firm Admin · AVS Gold ERP" }] }),
  component: AdminLayout,
});

function AdminLayout() {
  const navigate = useNavigate();
  const { can } = useCan();
  const canUsers = can("userManagement.view");
  const canSettings = can("settings.view");

  useEffect(() => {
    if (!canUsers && !canSettings) {
      void navigate({ to: "/app", replace: true });
    }
  }, [canUsers, canSettings, navigate]);

  if (!canUsers && !canSettings) {
    return null;
  }

  return (
    <div className="space-y-4">
      <PageHeader
        title="Firm Admin"
        description="Manage your shop, employees, modules, and business settings. Platform controls are in SaaS Admin."
      />
      <Outlet />
    </div>
  );
}
